namespace GeniuzPOS.Purchase {
    export interface PoSupplierRow {
        Id?: number;
        SupplId?: string;
        SupplName?: string;
        SupplType?: number;
        ContactName?: string;
        SupTelNo?: string;
        SupEmail?: string;
        SupplAddress?: string;
        Remark?: string;
        SupplRegName?: string;
        SupplRegAddress?: string;
        SupplTaxId?: string;
        ConsignFg?: number;
        ConsignGp?: number;
        ReturnOutRemark?: string;
        SupplierShortName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        TelNoExt?: string;
        TelMobile?: string;
        FaxNo?: string;
        FaxExt?: string;
        CompanyCode?: string;
        BranchCode?: string;
        BranchName?: string;
        PayMethod?: string;
        CreditTerm?: number;
        TradeTerm?: string;
        AuthPerson?: string;
        AuthTel?: string;
        AuthTelExt?: string;
        AuthMobile?: string;
        AuthEmail?: string;
        SalePerson?: string;
        SaleTel?: string;
        SaleTelExt?: string;
        SaleMobile?: string;
        SaleEmail?: string;
        PurVatCode?: string;
        PurVatType?: string;
        PurVatRate?: number;
        Ctaxtype?: string;
        ErpVenderCode?: string;
        ErpVendorType?: string;
        ErpSreachName?: string;
        ErpVendorBlock?: string;
        CustBranch?: string;
        Status?: string;
    }

    export namespace PoSupplierRow {
        export const idProperty = 'SupplId';
        export const nameProperty = 'SupplId';
        export const localTextPrefix = 'Purchase.PoSupplier';
        export const lookupKey = 'Purchase.PoSupplier';

        export function getLookup(): Q.Lookup<PoSupplierRow> {
            return Q.getLookup<PoSupplierRow>('Purchase.PoSupplier');
        }
        export const deletePermission = '5Purchase:ผู้จำหน่าย:Modify';
        export const insertPermission = '5Purchase:ผู้จำหน่าย:Modify';
        export const readPermission = '5Purchase:ผู้จำหน่าย:View';
        export const updatePermission = '5Purchase:ผู้จำหน่าย:Modify';

        export declare const enum Fields {
            Id = "Id",
            SupplId = "SupplId",
            SupplName = "SupplName",
            SupplType = "SupplType",
            ContactName = "ContactName",
            SupTelNo = "SupTelNo",
            SupEmail = "SupEmail",
            SupplAddress = "SupplAddress",
            Remark = "Remark",
            SupplRegName = "SupplRegName",
            SupplRegAddress = "SupplRegAddress",
            SupplTaxId = "SupplTaxId",
            ConsignFg = "ConsignFg",
            ConsignGp = "ConsignGp",
            ReturnOutRemark = "ReturnOutRemark",
            SupplierShortName = "SupplierShortName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            TelNoExt = "TelNoExt",
            TelMobile = "TelMobile",
            FaxNo = "FaxNo",
            FaxExt = "FaxExt",
            CompanyCode = "CompanyCode",
            BranchCode = "BranchCode",
            BranchName = "BranchName",
            PayMethod = "PayMethod",
            CreditTerm = "CreditTerm",
            TradeTerm = "TradeTerm",
            AuthPerson = "AuthPerson",
            AuthTel = "AuthTel",
            AuthTelExt = "AuthTelExt",
            AuthMobile = "AuthMobile",
            AuthEmail = "AuthEmail",
            SalePerson = "SalePerson",
            SaleTel = "SaleTel",
            SaleTelExt = "SaleTelExt",
            SaleMobile = "SaleMobile",
            SaleEmail = "SaleEmail",
            PurVatCode = "PurVatCode",
            PurVatType = "PurVatType",
            PurVatRate = "PurVatRate",
            Ctaxtype = "Ctaxtype",
            ErpVenderCode = "ErpVenderCode",
            ErpVendorType = "ErpVendorType",
            ErpSreachName = "ErpSreachName",
            ErpVendorBlock = "ErpVendorBlock",
            CustBranch = "CustBranch",
            Status = "Status"
        }
    }
}
